import React from 'react';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';

import DottedArrowInfographicItem from './DottedArrowInfographicItem';
import Icon from 'js/components/common/Icon';
import DAINavigatorButton from './DAINavigatorButton';

const InfographicContainer = styled.div`
  & {
    overflow: hidden;
    padding: 10px;
    position: relative;
  }

  @media(max-width: ${device.laptop}) {
    & {
      display: flex;
      max-height: 350px;
    }
  }

  @media(max-width: ${device.laptop}) {
    .pod-infographic-item::after {
      background-size: 70px;
    }
  }
  @media(min-width: ${device.laptop}) {
    display: flex;
    flex-direction: row;

    & {
      padding: 30px;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

const CarouselContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  @media(min-width: ${device.laptop}) {
    transform: translate(0%) !important;
  }
`;

const CarouselWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

function DottedArrowInfographic({ children, elements }) {
  const [activeItem, setActiveItem] = useState(0);
  const carouselBox = useRef();
  const podItems = elements.map((item, index) => (
    <DottedArrowInfographicItem step={index + 1} key={index}>
      {item}
    </DottedArrowInfographicItem>
  ));

  const onChevronClicked = (moveValue) => {
    const nextVal = activeItem + moveValue;
    const el = podItems[nextVal];
    setActiveItem(nextVal);
  };
  return (
    <InfographicContainer className="pod-infographic-container">
      <DAINavigatorButton
        disabled={activeItem === 0}
        iconName="chevron-left"
        left="0px"
        onAction={() => onChevronClicked(-1)}
      />
      <CarouselWrapper>
        <CarouselContainer
          ref={carouselBox}
          style={{
            transform: `translate(-${activeItem * 100}%)`
          }}
        >
          {podItems}
        </CarouselContainer>
      </CarouselWrapper>
      <DAINavigatorButton
        disabled={activeItem === elements.length - 1}
        iconName="chevron-right"
        right="0px"
        onAction={() => onChevronClicked(1)}
      />
    </InfographicContainer>
  )
}

export default DottedArrowInfographic;